import Drawer from '@/components/drawer';
import { DrawerContext } from '@/hooks/drawer.hook';
import { ReactElement, ReactNode, useState } from 'react';

interface DrawerProviderProps {
  children: ReactNode;
}

export default function DrawerProvider({ children }: DrawerProviderProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [drawerContent, setDrawerContent] = useState<ReactElement | null>(null);

  const openDrawer = (content: ReactElement) => {
    setDrawerContent(content);
    setIsOpen(true);
  };

  const closeDrawer = () => {
    setIsOpen(false);
    setDrawerContent(null);
  };

  const changeDrawerContent = (content: ReactElement) => {
    setDrawerContent(content);
  };

  return (
    <DrawerContext.Provider
      value={{ openDrawer, closeDrawer, changeDrawerContent, isOpen }}
    >
      {children}
      <Drawer open={isOpen}>{drawerContent}</Drawer>
    </DrawerContext.Provider>
  );
}
